'use client'
import { notFound, unauthorized } from 'next/navigation'
import Page401 from '~/components/error/401';
import Page404 from '~/components/error/404';
import Page500 from '~/components/error/500'
import { HttpNameError } from '~/lib/errors'

export default function Error({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
    if (error.name === HttpNameError.INTERNAL_SERVER_ERROR) {
        return <Page500 reset={reset} />
    }
    if (error.name === HttpNameError.NOT_FOUND) {
        return <Page404 />
    }
    if (error.name === HttpNameError.UNAUTHORIZED) {
        return <Page401 />
    }
    return <Page500 reset={reset} />
}
